import { Map } from 'immutable'
import { createSelector } from 'reselect'

const getLoginState = (state: Map<string, any>) => state?.get('login')

export const getHasFetchedUser = createSelector(getLoginState, (login) => login.get('hasFetchedUser'))
